/** Jours condensés (fr) — dim=0 … sam=6 */
const WEEKDAYS_SHORT = ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'];

/** Mois condensés (fr) */
const MONTHS_SHORT = [
  'janv.',
  'févr.',
  'mars',
  'avr.',
  'mai',
  'juin',
  'juil.',
  'août',
  'sept.',
  'oct.',
  'nov.',
  'déc.',
];

/**
 * Format condensé : « lun 25 août »
 * @param {string|Date|null|undefined} value
 * @returns {string|null}
 */
export function formatCondensedFrDate(value) {
  if (!value) {
    return null;
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return `${WEEKDAYS_SHORT[date.getDay()]} ${date.getDate()} ${MONTHS_SHORT[date.getMonth()]}`;
}

/**
 * Libellé « depuis » pour le statut BAT Validé.
 * @param {string|Date|null|undefined} batValideAt
 * @param {string|null|undefined} statutPhase
 * @returns {string|null}
 */
export function formatBatValideDepuisLabel(batValideAt, statutPhase) {
  if (statutPhase !== 'BAT Validé') {
    return null;
  }
  return formatCondensedFrDate(batValideAt);
}
